// extracted by mini-css-extract-plugin
export default {"button":"dashboard-filters_button__m+C7v","selected":"dashboard-filters_selected__VfucY"};